import React, {useState, useEffect} from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../global/components/Constants';
import { sortById } from '../utils/globalUtils';
import TopicComponentList from './components/TopicComponentList';
import TopicDetailHeader from './components/TopicDetailHeader';
import './components/topic-styles.css';
import PageLoader from '../global/components/PageLoader';


function TopicDetail() {

    const [topic, setTopic] = useState(null);
    const [topicComponents, setTopicComponents] = useState([]);
    const [loading, setLoading] = useState(false);

    const { code } = useParams();

    useEffect(()=>{
        loadTopic();
    }, []);

    function loadTopic(){
        setLoading(true);
        axios({
            method: 'get',
            url: API_URL + `topic/topic_by_slug?slug=${code}`,
        }).then((respose)=>{
            const obj = respose.data;
            if(obj.Success){
                setTopic(obj.Data);
                setLoading(false);
            }
        });
    }

    const styles = {
        header:{
        },
        body:{
            background: '#fff',
            minHight: 300,
            paddingTop: 30,
            paddingBottom: 100
        },
    }

    const display = (
        <section style={styles.body}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-9'>
                        <div>
                            <TopicDetailHeader topic={topic} />
                            <TopicComponentList code={code} edit={false} />
                        </div>
                    </div>
                    <div className='col-md-3'></div>
                </div>
            </div>
        </section>
    )

    if(loading){
        return <PageLoader top={50} bottom={50} />
    }else{
        return (topic) && display;
    }
    
}

export default TopicDetail;